/* eslint-disable camelcase */
import { axiosJWT } from '@plugins/axios'

export default {
  postHit: async (app_id: number, url: string): Promise<void> => {
    await axiosJWT.post('hits', { app_id, url })
  },
}
